import { Field } from "../components/ExtraFields/types";
import { ExtraFieldResponse, IExtraFieldApiCall, IRestApiService } from "../types";

const baseUrl = 'extra-field/';
const configUrl = baseUrl + 'config/';

class ExtraFieldApiCall implements IExtraFieldApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getAllConfigs(context: string, ownerId: string): Promise<Field[]> {
    const url = `${context}/${ownerId}`;
    return this.restApiService.get(configUrl + url);
  }

  getAllDeletedConfigs(context: string, ownerId: string): Promise<Field[]> {
    const url = `${context}/${ownerId}/deleted`;
    return this.restApiService.get(configUrl + url);
  }

  getOneConfig(context: string, ownerId: string, id: string): Promise<Field> {
    const url = `${context}/${ownerId}/${id}`;
    return this.restApiService.get(configUrl + url);
  }

  createOneConfig(context: string, ownerId: string, data: Omit<Field, '_id'>): Promise<Field> {
    const url = `${context}/${ownerId}`;
    return this.restApiService.post(configUrl + url, data);
  }

  deleteOneConfig(context: string, ownerId: string, id: string, force?: boolean): Promise<void> {
    let url = `${context}/${ownerId}/${id}`;
    if (force) {
      url += '?force=true';
    }
    return this.restApiService.delete(configUrl + url);
  }

  updateOneConfig(context: string, ownerId: string, id: string, data: Field): Promise<Field> {
    const url = `${context}/${ownerId}/${id}`;
    return this.restApiService.put(configUrl + url, data);
  }

  restoreOneConfig(context: string, ownerId: string, id: string): Promise<Field> {
    const url = `${context}/${ownerId}/${id}/restore`;
    return this.restApiService.post(configUrl + url);
  }

  // context = attendence, project, task, ...
  // ownerId = id of user
  // contextId = id of project, task, ...
  getAllValues(context: string, ownerId: string, contextId: string): Promise<ExtraFieldResponse> {
    const url = `${context}/${ownerId}/${contextId}`;
    return this.restApiService.get(baseUrl + url);
  }

  // context = attendence, project, task, ...
  // ownerId = id of user
  // contextId = id of project, task, ...
  // fieldId = name of field: status, experience, gold
  saveValue(context: string, ownerId: string, contextId: string, fieldId: string, value: any): Promise<void> {
    const url = `${context}/${ownerId}/${contextId}/${fieldId}`;
    return this.restApiService.post(baseUrl + url, { value });
  }

  deleteValue(context: string, ownerId: string, contextId: string, id: string): Promise<void> {
    const url = `${context}/${ownerId}/${contextId}/${id}`;
    return this.restApiService.delete(baseUrl + url);
  }
}

export default ExtraFieldApiCall;